<template>
  <div>
    <h3 class="text-2xl max-w-2xl text-vice-teal-900 font-semibold leading-tight">
      Other statistics
    </h3>
    <div class="relative overflow-x-auto shadow-md sm:rounded-lg mt-5 mb-10">
      <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead
          class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
        >
          <tr>
            <th scope="col" class="px-6 py-3">Name</th>
            <th scope="col" class="px-6 py-3">OS, Browser</th>
            <th scope="col" class="px-6 py-3">Screen</th>
            <th scope="col" class="px-6 py-3">Camera</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="userSystemData in otherStatisticsData"
            :key="userSystemData.name"
            class="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
          >
            <th
              scope="row"
              class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
            >
              {{ userSystemData.name }}
            </th>
            <td class="px-6 py-4">{{ userSystemData.os_browser }}</td>
            <td class="px-6 py-4">{{ userSystemData.screen }}</td>
            <td class="px-6 py-4">{{ userSystemData.camera }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OtherStatistics',
  props: {
    otherStatisticsData: {
      require: true,
    },
  },
};
</script>

<style scoped></style>
